/* Marisole — custom behaviour. Dependency-free, Theme-Editor safe.
   Custom elements auto-init on connect and clean up on disconnect,
   so they survive shopify:section:load/unload without duplicate listeners. */
(function () {
  if (window.customElements && !customElements.get('ms-countdown')) {
    class MsCountdown extends HTMLElement {
      connectedCallback() {
        this.endTime = this.getAttribute('data-end');       // ISO string or empty
        this.expiredText = this.getAttribute('data-expired-text') || '';
        this.hideOnExpire = this.getAttribute('data-hide-on-expire') === 'true';
        this.display = this.querySelector('[data-countdown-display]');
        this.expiredEl = this.querySelector('[data-countdown-expired]');
        this.barEl = this.closest('[data-announcement-bar]');
        if (!this.endTime || !this.display) { return; }
        this.target = new Date(this.endTime).getTime();
        if (isNaN(this.target)) { return; }
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { if (this.timer) clearInterval(this.timer); }
      pad(n) { return n < 10 ? '0' + n : '' + n; }
      tick() {
        const diff = this.target - Date.now();
        if (diff <= 0) {
          clearInterval(this.timer);
          if (this.hideOnExpire && this.barEl) { this.barEl.setAttribute('hidden', ''); return; }
          if (this.display) this.display.setAttribute('hidden', '');
          if (this.expiredEl && this.expiredText) { this.expiredEl.textContent = this.expiredText; this.expiredEl.removeAttribute('hidden'); }
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        const parts = this.display.querySelectorAll('[data-unit]');
        const vals = { days: d, hours: h, minutes: m, seconds: s };
        parts.forEach((el) => { const k = el.getAttribute('data-unit'); el.textContent = k === 'days' ? d : this.pad(vals[k]); });
        // hide day group when zero days to stay compact
        const dayGroup = this.display.querySelector('[data-day-group]');
        if (dayGroup) dayGroup.style.display = d > 0 ? '' : 'none';
      }
    }
    customElements.define('ms-countdown', MsCountdown);
  }
})();
